import React from "react";
import StudyBuddyPracticePage from "./StudyBuddyPracticePage";

export default function StudyBuddyPracticeEmbedPage(){return <StudyBuddyPracticePage embed/>;}
